import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Tenant } from 'src/app/models/tenant';

@Component({
    selector: 'app-tenant-switcher',
    templateUrl: './tenant-switcher.component.html',
    styleUrls: ['./tenant-switcher.component.css'],
    standalone: false
})
export class TenantSwitcherComponent {
    @Input() tenant: Tenant;
    @Input() accessibleTenants: Tenant[] = [];
    @Output() switchTenant$ = new EventEmitter<Tenant>();
    @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

    // The overlay panel is measured once at open; resize would leave rows escaping the painted panel.
    @HostListener('window:resize')
    closeMenuOnResize(): void {
        this.menuTrigger?.closeMenu();
    }
}
